module.exports = __webpack_public_path__ + "static/img/30015 (4).d5af733.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30015 (4).webp
// module id = iqcb
// module chunks = 14